// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"34fcffcb47fea84e45f8","655":"d22541f52c28c754c550"}[chunkId] + ".js";
};